<div class="modal-overlay" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Give Your Feedback</h2>
      <button class="close-btn" (click)="closeModal()">&#x2715;</button>
    </div>
    <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()">
      <div class="form-group">
        <label for="rating">Rating (1-5)</label>
        <input type="number" id="rating" formControlName="rating" min="1" max="5" />
        <div *ngIf="feedbackForm.get('rating')?.invalid && feedbackForm.get('rating')?.touched">
          <small>Please provide a valid rating between 1 and 5.</small>
        </div>
      </div>
      <div class="form-group">
        <label for="title">Title</label>
        <input type="text" id="title" formControlName="title" />
        <div *ngIf="feedbackForm.get('title')?.invalid && feedbackForm.get('title')?.touched">
          <small>Title is required.</small>
        </div>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" formControlName="description"></textarea>
        <div *ngIf="feedbackForm.get('description')?.invalid && feedbackForm.get('description')?.touched">
          <small>Description is required.</small>
        </div>
      </div>
      <span class="error-login cursor-pointer block my-2 text-sm text-red-500 block my-2" *ngIf="!isLoggedIn" routerLink="/auth">Please Login to Submit Feedback</span>
      <button type="submit" [disabled]="feedbackForm.invalid || !isLoggedIn" class="submit-btn">Submit</button>
    </form>
  </div>
</div>